export default function SwapFooter() {
  return (
    <a className="widget__powered-by" href="/#">
      <span>Powered by</span>
      <img src="img/chainspot-logo.svg" width="80" height="16" alt="" />
    </a>
  );
}
